import { ITransactionsApi } from '../types';
import { instance, v2Instance } from './instance';

export const transactionsApi: ITransactionsApi = {
  getAllTransactions: async ({ query, page }) =>
    await v2Instance.get(
      `/admin/transactions/?page=${page || 1}${query ? `${query}` : ''}`
    ),

  getWalletTransactions: async ({ page, query }) =>
    await instance.get(
      `/admin/wallet/transactions/?page=${page || 1}${query ? `${query}` : ''}`
    ),
  getWalletAnalytics: async ({ query }) =>
    await instance.get(
      `/admin/wallet/analytics${
        query ? `?${query.startsWith('&') ? query.substring(1) : query}` : ''
      }`
    ),
  exportWalletTransactions: async ({ query }) =>
    await instance.get(
      `/admin/wallet/transactions/export${
        query ? `?${query.startsWith('&') ? query.substring(1) : query}` : ''
      }`
    ),
  createWalletEntry: async (payload) =>
    await instance.post(`/admin/wallet/entry/`, payload),

  fundUserWallet: async (payload) =>
    await instance.post(`/wallets/fund`, payload),

  getOtp: async () => await instance.get(`/wallets/fund/otp`),

  resolveAccountNumber: async ({ accountNumber, bankCode }) =>
    await instance.get('/paystack/resolve-account-number', {
      params: { accountNumber, bankCode },
    }),

  getBankDetails: async (tenantId: string) =>
    await instance.get(
      `/disbursement-config/tenant/bank-details?tenantId=${tenantId}`
    ),

  createBankDetails: async ({ tenantId, payload }) =>
    await instance.post(
      `/disbursement-config/tenant/bank-details?tenantId=${tenantId}`,
      payload
    ),

  updateBankDetails: async ({ bankDetailId, tenantId, payload }) =>
    await instance.put(
      `/disbursement-config/tenant/bank-details/${bankDetailId}?tenantId=${tenantId}`,
      payload
    ),
};
